<template>
  <v-skeleton-loader v-if="!ready" type="article"></v-skeleton-loader>
  <div v-else>
    <v-card tile>
      <v-card-text>
        <v-row dense>
          <!-- 样品方案、分组、比较组 -->
          <v-col cols="12">
            <v-row>
              <v-col cols="3">
                <v-select
                  :items="schemaList"
                  v-model="schemaValue"
                  item-text="name"
                  item-value="name"
                  :disabled="editFlag"
                  dense
                  outlined
                  label="请选择样品设置方案"
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  color="primary"
                  @click="schemaEdit = true"
                  text
                  :disabled="editFlag || (shareData && !shareData.analyseExec)"
                  >新建样品设置方案</v-btn
                >
                <v-btn
                color="primary"
                :disabled="shareData && !shareData.analyseExec"
                @click="deleteSchema" text
                  >删除样品设置方案</v-btn
                >
              </v-col>
            </v-row>
          </v-col>

          <template v-if="schemaValue">
            <!-- 输入参数 -->
            <v-col cols="12" v-if="params.length">
              <analyse-param-form
                ref="paramForm"
                :items="params"
                :coder="coder"
                :disabled="resultExists && !editFlag"
              ></analyse-param-form>
            </v-col>
            <v-col cols="12">
              <template v-if="resultExists">
                <v-row v-if="!editFlag">
                  <v-btn :disabled="shareData && !shareData.analyseExec" color="primary" style="margin-left: 10px" @click="onEditParam">修改参数</v-btn>
                  <span v-if="shareData && !shareData.analyseExec" style="color: #FF0000; font-size: 12px;line-height: 36px; margin-left: 10px">*您没有当前项目的流程分析权限，请联系项目分享人</span>
                </v-row>
                <v-row v-else dense>
                  <v-col cols="3">
                    <v-text-field
                      ref="newSchemaName"
                      label="方案名称"
                      placeholder="请输入新的方案名称"
                      v-model="newSchemaName"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn color="primary" text @click="editFlag = false"
                      >取消</v-btn
                    >
                    <v-btn color="primary" @click="onCopyAndExecute"
                      >运 行</v-btn
                    >
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-btn color="primary" @click="onExecute">运 行</v-btn>
              </template>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>

    <template v-if="schemaValue">
      <v-card flat>
        <v-card-title>样品信息</v-card-title>
        <v-card-text>
          <table-editor
            :header="sampleHeader"
            :items="sampleItems"
          ></table-editor>
        </v-card-text>
      </v-card>

      <v-card flat>
        <v-card-title>样品分组信息</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              :cols="col"
              v-for="(group, i) in groupList"
              :key="`group_${i}`"
            >
              <v-card outlined class="rounded-0">
                <v-card-title>{{ group.name }}</v-card-title>
                <v-card-text>
                  <v-chip-group column>
                    <v-chip
                      small
                      disabled
                      v-for="item in sampleItems.filter(
                        (s, idx) => group.nos.indexOf(idx) != -1
                      )"
                      :key="item[0]"
                      >{{ item[1] }}</v-chip
                    >
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card tile>
        <v-card-title>比较组信息</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              :cols="col"
              v-for="(groupVS, i) in groupVSList"
              :key="`groupVS_${i}`"
            >
              <v-card outlined class="rounded-0">
                <v-card-subtitle>
                  <template v-if="groupVS.length == 2">两组比较</template>
                  <template v-else>多组比较</template>
                </v-card-subtitle>
                <v-card-text>
                  <v-row
                    v-if="groupVS.length == 2"
                    dense
                    align="center"
                    justify="center"
                  >
                    <v-col cols="5" class="text-center">
                      <div class="caption">分子组/实验组</div>
                      {{ groupVS[0] }}
                    </v-col>
                    <v-col cols="auto">
                      <h5 class="pt-6">VS</h5>
                    </v-col>
                    <v-col cols="5" class="text-center">
                      <div class="caption">分母组/对照组</div>
                      {{ groupVS[1] }}
                    </v-col>
                  </v-row>
                  <v-chip-group v-else column>
                    <v-chip
                      small
                      disabled
                      v-for="item in groupVS"
                      :key="item"
                      >{{ item }}</v-chip
                    >
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <schema-edit-dialog
      v-model="schemaEdit"
      :type="type"
      :xmh="xmh"
      :report-data="reportData"
      @ok="onSaveSchema"
    ></schema-edit-dialog>
  </div>
</template>
<script>
// 样品信息设置
import {
  userFileList,
  userFileRead,
  userFileWrite,
  userFileDelete,
  userFileCopy,
  runReportTask,
  reportSchemaCheck,
} from "@/plugins/api";
import { chineseText2 } from "@/plugins/rules";

export default {
  props: [
    "reportData",
    "reportId",
    "moduleId",
    "type",
    "xmh",
    "schema",
    "moduleDetailData",
    "projectInfo",
    "shareData"
  ],
  data() {
    return {
      col: 4,
      ready: false,
      schemaValue: this.schema,
      schemaEdit: false,
      schemaList: [], // 文件夹列表
      sampleData: [], // 样品分组文件内容
      groupVSData: [], // 比较组文件内容

      resultExists: false,
      editFlag: false,
      newSchemaName: null,
      chineseText2: chineseText2(),
    };
  },
  watch: {
    schemaValue() {
      this.onSchemaChange();
    },
  },
  components: {
    SchemaEditDialog: () => import("./SchemaEditDialog.vue"),
    AnalyseParamForm: () => import("../AnalyseParamForm.vue"),
  },
  created() {
    this.init();
  },
  // mounted () { this.init() },
  computed: {
    coder() {
      return this.moduleDetailData.coder;
    },
    params() {
      return this.moduleDetailData.params;
    },
    groupList() {
      let ret = [];
      for (let i = 0; i < this.sampleItems.length; i++) {
        let row = this.sampleItems[i];
        let c2 = row[3];
        if (!c2) continue;
        let names = c2.split(";");
        for (let m = 0; m < names.length; m++) {
          let name = names[m];
          let exists = ret.find((item) => item.name == name);
          if (!exists) ret.push({ name: name, nos: [i] });
          else exists.nos.push(i);
        }
      }
      return ret;
    },
    groupVSList() {
      let ret = [];
      for (let i = 1; i < this.groupVSData.length; i++) {
        let c0 = this.groupVSData[i][0];
        if (c0.indexOf("_vs_") != -1) ret.push(c0.split("_vs_"));
        else ret.push(c0.substring(0, c0.indexOf("_oneway")).split("_"));
      }
      return ret;
    },
    sampleHeader() {
      return this.sampleData.length
        ? this.sampleData[0].map((v, i) => Object({ code: i, name: v }))
        : [];
    },
    sampleItems() {
      return this.sampleData.length ? this.sampleData.slice(1) : [];
    },
  },
  methods: {
    deleteSchema() {
      this.$message.confirm(`您确定要删除项目“${this.schemaValue}”吗？`, () => {
        if (this.schemaValue === "Schema") {
          setTimeout(() => {
            this.$message.success("不能删除默认样品设置方案");
          });
          return;
        }
        const { csj, xmh } = this.$route.query;
        const params = {
          ypbh: xmh,
          csj,
          dirName: this.schemaValue,
        };
        userFileDelete(params).then((res) => {
          if (res.status === 1) {
            this.$message.success("删除样品设置方案已成功");
            this.init();
          }
        });
      });
    },
    async init() {
      await userFileList({
        path: `/${this.type}/${this.xmh}/Design`,
        regex: "Schema.*",
      }).then((res) => (this.schemaList = res.data));
      if (this.schemaValue) {
        let sr = this.schemaList.find((sm) => sm.name == this.schemaValue);
        if (!sr) {
          this.$message.error(
            `样品方案[${this.schemaValue}]不存在,已为您切换至默认方案`
          );
          this.schemaValue = "Schema";
          await this.onSchemaChange();
        } else await this.loadSchemaDetail();
      }
      this.ready = true;
    },

    async onExecute() {
      let schemaSummary = this.getSchemaSummary();
      let valid = await this.validateSchemaSummary(schemaSummary);
      if (valid === false) return;
      this.runTask(schemaSummary);
    },
    async runTask(schemaSummary) {
      schemaSummary.items = schemaSummary.summary.param;
      delete schemaSummary.summary.param;
      await runReportTask(schemaSummary).then(() => {
        this.$message.success("已成功提交任务,请关注分析结果");
        this.resultExists = true;
        this.editFlag = false;
        // 重新加载输入参数表单
      });
    },

    onSaveSchema(e) {
      let path = e[0].path,
        ps = path.split("/"),
        name = ps[ps.length - 1],
        ns = name.split("_"),
        alias = ns[1];
      let newSchemaRow = { alias: alias, name: name, path: path };

      // 校验方案名称是否存在
      let existsSchema = this.schemaList.find((row) => row.name == name);
      if (existsSchema) {
        this.$message.error("方案名称已存在,请重新输入");
        return;
      }

      userFileWrite(e).then(() => {
        this.schemaList.push(newSchemaRow);
        this.$message.success("操作成功");
        this.schemaEdit = false;
      });
    },
    async onCopyAndExecute() {
      // 校验
      if (
        !this.newSchemaName ||
        !this.chineseText2(this.newSchemaName)
      ) {
        this.$message.error("样品设置方案名称只允许输入数字、字母、中文、下划线");
        this.$refs.newSchemaName.focus();
        return;
      }
      // 校验方案名称是否存在
      let newName = "Schema_" + this.newSchemaName;
      let existsSchema = this.schemaList.find((row) => row.name == newName);
      if (existsSchema) {
        this.$message.error("方案名称已存在,请重新输入");
        return;
      }
      let schemaSummary = this.getSchemaSummary();
      // 校验方案参数是否存在
      let valid = await this.validateSchemaSummary(schemaSummary);
      if (valid === false) return;
      // 复制方案
      let copyGroupVSParam = {
        path: `/${this.type}/${this.xmh}/Design/${this.schemaValue}/GroupVS.xlsx`,
        tar: `/${this.type}/${this.xmh}/Design/${newName}/GroupVS.xlsx`,
      };
      await userFileCopy(copyGroupVSParam);
      let copySampleParam = {
        path: `/${this.type}/${this.xmh}/Design/${this.schemaValue}/Sample.xlsx`,
        tar: `/${this.type}/${this.xmh}/Design/${newName}/Sample.xlsx`,
      };
      await userFileCopy(copySampleParam);
      // 切换到当前复制的方案
      let newSchema = {
        dir: true,
        name: newName,
        path: `/${this.type}/${this.xmh}/Design/${this.schemaValue}`,
      };
      this.schemaList.push(newSchema);
      schemaSummary.summary.name = newName;
      schemaSummary.basicParam.schema = newName;
      await this.runTask(schemaSummary);
      this.schemaValue = newName;
    },

    onEditParam() {
      this.editFlag = true;
    },

    // 获取summary
    getSchemaSummary() {
      let ret = {
        basicParam: {
          reportId: this.reportId,
          moduleId: this.moduleId,
          type: this.type,
          xmh: this.xmh,
          schema: this.schemaValue,
          oaProjectInfo: JSON.stringify(this.projectInfo)
        },
        summary: { name: this.schemaValue, sample: [], vs: [], param: [] },
      };
      this.sampleItems.forEach((row) =>
        ret.summary.sample.push({ code: row[1], name: row[2], group: row[3] })
      );
      this.groupVSData.slice(1).forEach((row) => ret.summary.vs.push(row[0]));
      if (this.params.length)
        ret.summary.param = this.$refs.paramForm.getBillData();
      return ret;
    },
    // 方案校验
    async validateSchemaSummary(currReportSchema) {
      let sameSchemaSummary;
      await reportSchemaCheck(currReportSchema).then(
        (res) => (sameSchemaSummary = res.data)
      );
      if (sameSchemaSummary) {
        this.$message.error(`已存在相同设置的方案:[${sameSchemaSummary.name}]`);
        return false;
      }
    },

    async onSchemaChange() {
      await this.loadSchemaDetail();
      this.$emit("valueChanged", this.schemaValue);
    },

    async loadSchemaDetail() {
      // 加载样品信息（含分组）
      await userFileRead({
        path: `/${this.type}/${this.xmh}/Design/${this.schemaValue}/Sample.xlsx`,
      }).then((res) => (this.sampleData = res.data));
      // 加载比较组信息
      await userFileRead({
        path: `/${this.type}/${this.xmh}/Design/${this.schemaValue}/GroupVS.xlsx`,
      }).then((res) => (this.groupVSData = res.data));
      await userFileRead({
        path: `/${this.type}/${this.xmh}/Result/${this.schemaValue}`,
        stream: false,
      }).then((res) => (this.resultExists = res.data));
      if (this.params.length) {
        this.$nextTick(async () => {
          // 加载之前输入的参数信息
          await userFileRead({
            path: `/${this.type}/${this.xmh}/Design/${this.schemaValue}/Parameters.xlsx`,
          }).then((res) => {
            if (res.data) {
              let itemValues = {};
              res.data.slice(1).forEach((row) => {
                let code = row[0];
                let param = this.params.find((p) => p.code == code);
                if (param) itemValues[code] = row[1];
              });
              this.$refs.paramForm.setItemValues(itemValues);
            } else {
              this.$refs.paramForm.reset();
            }
          });
        });
      }
    },
  },
};
</script>
